module.exports = __webpack_public_path__ + "static/media/recent-light-gray.2324a5be.svg";